import { PinPluginsList } from "./PinPluginsList";

export default PinPluginsList;
